'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ablyToPubnubMessage = exports.ablyToPubnubMessage = function ablyToPubnubMessage(channel, ablyMessage) {
  return {
    channel: channel,
    timestamp: ablyMessage.timestamp,
    timetoken: ablyMessage.timestamp + '0000',
    message: ablyMessage.data
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/operators/ablyToPubnubMessage.js
// module id = 776
// module chunks = 2 3